import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { graphql, useStaticQuery } from 'gatsby';
import Portfolio from './Portfolio';
import PortfolioHexGrid from '../../components/hexButtonGrids/PortfolioHexGrid';
import { projectList } from '../../constants';


const MainContainer = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.colors.blue};
  width: 100%;
  text-align: center;
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 400px;
  justify-content: center;
  
  @media (min-width: ${({ theme }) => theme.screenSizeWidth.extraSmall}){
    padding-bottom: 550px;
  }
  
  @media (min-width: ${({ theme }) => theme.screenSizeWidth.small}){
    padding-bottom: 450px;
  }
  
  @media (min-width: ${({ theme }) => theme.screenSizeWidth.medium}){
    padding-bottom: 180px;
  }
  
  @media (min-width: ${({ theme }) => theme.screenSizeWidth.large}){
    padding-bottom: 250px;
  }
`;

interface File {
  publicURL: string,
  name: string,
}

const Projects = () => {
  const { t } = useTranslation();
  const { allFile } = useStaticQuery<ListQuery<File>>(graphql`
  query {
    allFile(filter: {extension: {regex: "/(svg)/"}, relativeDirectory: {regex: "/(projects)/"}}) {
      nodes {
        publicURL
        name
      }
    }
  }
  `);

  const namePublicUrlMap = allFile.nodes.reduce(
    (prevValue: object, currentProject: File) => ({
      ...prevValue,
      [currentProject.name]: currentProject.publicURL,
    }),
    {}
  );

  const projectListWithIcons: PortfolioProjectWithUrl[] = projectList.map((project) => ({
    ...project,
    publicURL: namePublicUrlMap[project.name],
  }));


  return (
    <MainContainer>
      <h1>
        {t('ourProjects')}
      </h1>
      <Portfolio />
      <PortfolioHexGrid
        projectsList={projectListWithIcons}
      />
    </MainContainer>
  );
};

export default Projects;
